import { render, staticRenderFns } from "./PdfViewer.vue?vue&type=template&id=c3ee464e&scoped=true"
import script from "./PdfViewer.vue?vue&type=script&lang=ts"
export * from "./PdfViewer.vue?vue&type=script&lang=ts"
import style0 from "./PdfViewer.vue?vue&type=style&index=0&id=c3ee464e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ee464e",
  null
  
)

export default component.exports